import axios from 'axios'

export default {
  getExplorer: async (
    sitePath,
    bpReference,
    processId,
    searchText,
    filters_form,
    units_offset,
    units_sort_by,
    units_sort_desc,
    pk,
    filter_dates,
    filter_directory
  ) => {
    const bp = encodeURIComponent(bpReference)
    const text = encodeURIComponent(searchText)
    if (units_sort_desc) var sort_order = 'D'
    else var sort_order = 'A'
    const epk = pk 
      ? `&pk=${encodeURIComponent(pk)}`
      : ''
    let url = `${sitePath}/unit/explorer/?business_process=${bp}&affected_process=${processId}&searchable_text=${text}&offset=${units_offset}&sort_by=${units_sort_by}&sort_order=${sort_order}${epk}`
    if (filters_form) {
      for (let [name, value] of filters_form.entries()) {
        if (value != '') {
          url += `&${name}=` + encodeURIComponent(`${value}`)
        }
      }
    }
    if (filter_dates.length == 2) {
      url += `&filter_dates=` + encodeURIComponent(`${filter_dates}`)
    }
    if (filter_directory.length > 0) {
      // filter_directory is a list of directory objects, we want a list of ids
      let dir_ids = [];
      for (const dir of filter_directory)
        dir_ids[dir_ids.length] = dir.id;
      url += `&filter_directory=` + encodeURIComponent(`${dir_ids}`)
    }
    const response = await axios.get(url)
    return response.data
  },

  getExplorerCalendar: async (
    sitePath,
    bpReference,
    processId,
    searchText,
    filters_form,    
    start,
    end
  ) => {
    const bp = encodeURIComponent(bpReference)
    const text = encodeURIComponent(searchText)
    let url = `${sitePath}/unit/explorer_calendar/?business_process=${bp}&affected_process=${processId}&searchable_text=${text}&start=${start}&end=${end}`
    
    if (filters_form) {
      for (let [name, value] of filters_form.entries()) {
        if (value != '') {
          url += `&${name}=` + encodeURIComponent(`${value}`)
        }
      }
    }
    
    const response = await axios.get(url)
    return response.data
  }, 
  
  getExplorerKPI: async (
    sitePath,
    bpReference,
    start_date,
    end_date,
    // searchText,
    // filters_form,
    // units_offset,
    // start,
    // end,
  ) => {
    const bp = encodeURIComponent(bpReference)

    let url = `${sitePath}/unit/explorer_report/?business_process=${bp}&start_date=${start_date}&end_date=${end_date}`
    /*
    if (filters_form) {
      for (let [name, value] of filters_form.entries()) {
        url += `&${name}=` + encodeURIComponent(`${value}`)
      }
    }
    */
    const response = await axios.get(url)

    return response.data
  },  
  
  getDefaultUrl: async sitePath => {
    const url = `${sitePath}/menuitem/get_default_url`
    const response = await axios.get(url)

    return response.data
  },

  getQUnit: async (sitePath, pk) => {
    const epk = encodeURIComponent(pk)
    const url = `${sitePath}/unit/${epk}/`
    const response = await axios.get(url)

    return response.data
  },

  getTransitionCandidates: async (sitePath, pk) => {
    const epk = encodeURIComponent(pk)
    const url = `${sitePath}/unit/${epk}/get_transition_candidates`
    const response = await axios.get(url)
    return response.data
  },

  getFieldsToCollectForFiltering: async (sitePath, bpReference) => {
    const bp = encodeURIComponent(bpReference)
    const apiUrl = encodeURIComponent(axios.defaults.baseURL + sitePath)
    const url = `${sitePath}/unit/get_fields_definition_to_collect_for_filtering/?business_process=${bp}&api_url=${apiUrl}`
    const response = await axios.get(url)

    return response.data
  },
  getFieldsToCollectDuringCreation: async (
    sitePath,
    bp_reference,
    origin_qunit,
  ) => {
    const bp = encodeURIComponent(bp_reference)
    const api_url = encodeURIComponent(axios.defaults.baseURL + sitePath)
    const origin_querystring = origin_qunit
      ? `&origin_qunit=${encodeURIComponent(origin_qunit)}`
      : ''
    const url = `${sitePath}/unit/get_fields_to_collect_during_creation/?business_process=${bp}&api_url=${api_url}${origin_querystring}`
    const response = await axios.get(url)

    return response.data
  },
  /* New method to vuetify components */
  getFieldsDefinitionToCollectDuringCreation: async (
    sitePath,
    bp_reference,
    origin_qunit,
  ) => {
    const bp = encodeURIComponent(bp_reference)
    const api_url = encodeURIComponent(axios.defaults.baseURL + sitePath)
    const origin_querystring = origin_qunit
      ? `&origin_qunit=${encodeURIComponent(origin_qunit)}`
      : ''
    const url = `${sitePath}/unit/get_fields_definition_to_collect_during_creation/?business_process=${bp}&api_url=${api_url}${origin_querystring}`
    const response = await axios.get(url)

    return response.data
  },

  getFieldsToCollectDuringTransition: async (sitePath, pk, transitionId) => {
    const epk = encodeURIComponent(pk)
    const apiUrl = encodeURIComponent(axios.defaults.baseURL + sitePath)
    const url = `${sitePath}/unit/${epk}/get_fields_to_collect_during_transition/?transition_id=${transitionId}&api_url=${apiUrl}`
    const response = await axios.get(url)

    return response.data
  },

  getTransitionCandidateResponsibles: async (sitePath, pk, transitionId) => {
    const epk = encodeURIComponent(pk)
    const url = `${sitePath}/unit/${epk}/get_transition_candidate_responsibles/?transition_id=${transitionId}`
    const response = await axios.get(url)

    return response.data
  },

  canCreate: async (sitePath, business_process) => {
    const url = `${sitePath}/unit/can_create?business_process=${business_process}`
    const response = await axios.get(url)
    return response.data
  },

  getQUnitFile: async (sitePath, pk, attribute, path) => {
    //
    // FIXME: Don't use path
    //
    const epk = encodeURIComponent(pk)
    const value = encodeURIComponent(path)
    const url = `${sitePath}/unit/${epk}/get_qunit_file/?attribute=${attribute}&path=${value}`
    const response = await axios.get(url, {responseType: 'arraybuffer'})
    //return response.data
    return response
  },

  createUnit: async (sitePath, formdata) => {
    // formdata is a FormData() instance
    const url = `${sitePath}/unit/create_and_execute_initial_transition/`
    // let con = true
    // console.log('business_process', addUnitBussinessProcess,'parent_process', addUnitParentProcess)

    // if (addUnitBussinessProcess) {
    //   formdata.append('business_process', addUnitBussinessProcess)  
    // } else {
    //   con = false
    //   console.log('not business_process')
    // }
    // if (addUnitParentProcess) {
    //   formdata.append('parent_process', addUnitParentProcess)
    // } else {
    //   // con = false
    //   console.log('not parent_process')
    // }
    
    // if (!con) return []
    
    const response = await axios({
      method: 'post',
      url: url,
      data: formdata,
      config: { headers: { 'Content-Type': 'multipart/form-data' } },
    })

    return response.data
  },

  executeTransition: async (sitePath, pk, form_data) => {
    const epk = encodeURIComponent(pk)
    const url = `${sitePath}/unit/${epk}/execute_transition/`

    const response = await axios({
      method: 'post',
      url: url,
      data: form_data,
      config: { headers: { 'Content-Type': 'multipart/form-data' } },
    })

    return response.data
  },
  
  getUserNotifications: async (sitePath, bp_reference, userid) => {
    const bp = encodeURIComponent(bp_reference)
    let url = `${sitePath}/unit/get_user_notifications/`
    const response = await axios.get(url)    

    return response.data
  },
  
  executeReadTransitionUserNotification: async (sitePath, pk) => {
    var notifications_ids = [pk]
    const epk = encodeURIComponent(notifications_ids)
    const url = `${sitePath}/unit/execute_read_notifications/`
    const response = await axios({
      method: 'post',
      url: url,
      data: {notifications_ids:notifications_ids},
      config: { headers: { 'Content-Type': 'multipart/form-data' } },
    })

    return response.data        
  },

  executeReadNotifications: async (sitePath, pks) => {
    const epks = encodeURIComponent(pks)
    const url = `${sitePath}/unit/execute_read_notifications/`
    const response = await axios({
      method: 'post',
      url: url,
      data: {notifications_ids:pks},
      config: { headers: { 'Content-Type': 'multipart/form-data' } },
    })

    return response.data        
  },

  getTodoList: async (
    sitePath,
    user_id,
    processId,
    searchText,
    filters_form,
    units_offset,
    units_sort_by,
    units_sort_desc,
    pk,
    filter_dates
  ) => {
    const text = encodeURIComponent(searchText)
    var sort_order = 'A'
    if (units_sort_desc) {
      sort_order = 'D'
    }
    // const epk = pk 
    //   ? `&pk=${encodeURIComponent(pk)}`
    //   : ''
    let url = `${sitePath}/unit/explorer_user_todo_list/?current_workflow_responsible=${user_id}&affected_process=${processId}&searchable_text=${text}&offset=${units_offset}&sort_by=${units_sort_by}&sort_order=${sort_order}`
    if (filters_form) {
      for (let [name, value] of filters_form.entries()) {
        url += `&${name}=` + encodeURIComponent(`${value}`)
      }
    }
    if (filter_dates.length == 2) {
      url += `&filter_dates=` + encodeURIComponent(`${filter_dates}`)
    }
    const response = await axios.get(url)
    return response.data
  },  
}
